import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import FAQSchema from './FAQSchema';

const FAQ = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const [openItems, setOpenItems] = useState([]);

  useEffect(() => {
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add('visible');
          observer.disconnect();
        }
      }, { threshold: 0.2 });
      
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
      
      return () => observer.disconnect();
    }
  }, []);

  const toggleItem = (index) => {
    setOpenItems(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  const faqData = [
    {
      question: t('faq.q1.question'),
      answer: t('faq.q1.answer')
    },
    {
      question: t('faq.q2.question'),
      answer: t('faq.q2.answer')
    },
    {
      question: t('faq.q4.question'),
      answer: t('faq.q4.answer')
    },
    {
      question: t('faq.q12.question'),
      answer: t('faq.q12.answer')
    }
  ];

  return (
    <section className="faq section-animate" id="faq" ref={sectionRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title title-animate">{t('faq.title')}</h2>
          <p className="section-subtitle subtitle-animate">
            {t('faq.subtitle')}
          </p>
        </div>
        
        <div className="faq-content">
        <div className="faq-list">
          {faqData.map((item, index) => (
            <div 
              key={index} 
              className={`faq-item stagger-item ${openItems.includes(index) ? 'open' : ''}`}
              onClick={() => toggleItem(index)}
            >
                <div className="faq-question">
              <h3>{item.question}</h3>
                  <div className="faq-icon">
                    <span className={`faq-arrow ${openItems.includes(index) ? 'open' : ''}`}>
                      ▲
                    </span>
                  </div>
                </div>
                <div className="faq-answer">
              <p>{item.answer}</p>
                </div>
            </div>
          ))}
          </div>
        </div>
      </div>
      <FAQSchema />
    </section>
  );
};

export default FAQ; 